import React from "react";
import { Modal } from "react-bootstrap";
import { moment } from "../common/common";
import NumberFormat from "react-number-format";
import { commonErr } from "../common/errors";
import { approveTripByOwner } from "../../model/car";
import { stypes } from "../common/common";

export default class ApproveTripOwner extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			step: 0, //0 confirm 1: approve trip
			errMsg: "",
			cancelReasons: null,
			ip_cancel_reason: "",
			ip_comment: "",
		};
	}

	handleInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	goToConfirm = () => {
		this.setState({
			step: 0,
			err: commonErr.INNIT,
		});
	};

	finishApprove = () => {
		this.props.hideModal();
		this.setState({
			step: 0,
			err: commonErr.INNIT,
		});
		this.getTrip();
	};

	getTrip = () => {
		this.props.getTrip(this.props.trip.id);
	};

	approveTrip = () => {
		approveTripByOwner(this.props.trip.id).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.setState({
					step: 1,
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			} else {
				this.setState({
					step: 1,
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	};

	render() {
		const { trip, car } = this.props;
		const isSeflDriveServiceType = trip.serviceType === stypes.SD;
		var content;
		if (this.state.step === 1) {
			if (this.state.err >= commonErr.SUCCESS) {
				content = (
					<div className="modal-confirm-body">
						<p className="font-14">Bạn đã đồng ý cho thuê xe.</p>
						<div className="wrap-btn">
							<a className="btn btn--m btn-primary" onClick={this.finishApprove}>
								Hoàn tất
							</a>
						</div>
					</div>
				);
			} else {
				content = (
					<div className="modal-confirm-body">
						<p className="font-14">Đồng ý yêu cầu thất bại. {this.state.errMsg}</p>
						<div className="wrap-btn">
							<a className="btn btn--m btn-primary" onClick={this.goToConfirm}>
								Thử lại
							</a>
						</div>
					</div>
				);
			}
		} else {
			content = (
				<div className="modal-confirm-body">
					<div className="block-content">
						<b>Thời gian thuê</b>
						<p className="font-14">Bắt đầu: {moment(trip.tripDateFrom).format("DD/MM/YYYY HH:mm")}</p>
						<p className="font-14">Kết thúc: {moment(trip.tripDateTo).format("DD/MM/YYYY HH:mm")}</p>
					</div>
					{isSeflDriveServiceType ? (
						<div className="block-content">
							<b>Địa điểm giao nhận xe</b>
							<p className="font-14">{trip.dAddr === car.locationAddr ? car.locationAddr : trip.dAddr}.</p>
						</div>
					) : (
						<div className="block-content">
							<b>Lộ trình</b>
							<p className="font-14">{trip.wd.routing.routes[0].addr}</p>
							{trip.wd.routing.routes.map((address, index) => {
								if (index === 0) return null;
								return <p className="font-14">{address.addr}</p>;
							})}
						</div>
					)}
					<div className="block-content">
						<b>Tổng đơn giá</b>
						<p className="font-14">
							<NumberFormat
								value={isSeflDriveServiceType ? trip.priceSummary.priceTotal : trip.wd.priceSummary.finalPrice}
								displayType={"text"}
								thousandSeparator={" "}
								decimalSeparator={","}
								suffix={"đ"}
							/>
						</p>
					</div>
					{trip.messageFromTraveller && trip.messageFromTraveller !== "" && (
						<div className="block-content">
							<b>Lời nhắn chủ xe</b>
							<p className="font-14">{trip.messageFromTraveller}</p>
						</div>
					)}
					<div className="wrap-btn has-2-btn">
						<a className="btn btn--m btn-primary" onClick={this.approveTrip}>
							Đồng ý
						</a>
						<a className="btn btn-link" onClick={this.finishApprove}>
							Bỏ qua
						</a>
					</div>
				</div>
			);
		}

		return (
			<Modal show={this.props.show} onHide={this.finishApprove} dialogClassName="modal-s modal-confirm">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Duyệt yêu cầu đặt xe</h5>
				</Modal.Header>
				<Modal.Body>{content}</Modal.Body>
			</Modal>
		);
	}
}
